


export default [
    {
        path: "current",
        name: "BillingDashboardCurrent",
        meta:{
            permissionPath: 'general_settings.billing_dashboard.read',
        },
        component: () =>
            import(
                /* webpackChunkName: "BillingDashboardCurrent" */ "@/views/general/settings/billingDashboard/tabs/Current.vue"
            )
    },

    {
        path: "payment-history",
        name: "BillingDashboardPaymentHistory",
        meta:{
            permissionPath: 'general_settings.billing_dashboard.read',
        },
        component: () =>
            import(
                /* webpackChunkName: "BillingDashboardPaymentHistory" */ "@/views/general/settings/billingDashboard/tabs/PaymentHistory.vue"
            )
    },

    {
        path: "payment-methods",
        name: "BillingDashboardPaymentMethods",
        meta:{
            permissionPath: 'general_settings.billing_dashboard.read',
        },
        component: () =>
            import(
                /* webpackChunkName: "BillingDashboardPaymentMethods" */ "@/views/general/settings/billingDashboard/tabs/PaymentMethods.vue"
            )
    },

    {
        path: "email-notifications",
        name: "BillingDashboardEmailNotifications",
        meta:{
            permissionPath: 'general_settings.billing_dashboard.read',
        },
        component: () =>
            import(
                /* webpackChunkName: "BillingDashboardEmailNotifications" */ "@/views/general/settings/billingDashboard/tabs/EmailNotifications.vue"
            )
    }
];
